// Routing Constants used throughout the application
export const TprecmRoutes = {
   TPRECM: 'tprecm',
   VIEW_UPDATE_TPR: 'view-update-tpr',
   RE_SOURCE: 're-source',
   INACTIVE: 'inactive',
   ECM: 'ecm',
   REQUEST_ACCES_FORM: 'request-access-form',
   REPORTS: 'report',
   METRICS: 'metrics'
};